export default __webpack_public_path__ + "static/Traffic2-267859a80e3518d326560e53973eae61.jpeg";